import './bootstrap'
import Map from './map';
import debounce from 'lodash-es/debounce';
import objectFitImages from 'object-fit-images';
import 'jquery-mask-plugin';

export default class Site {
  constructor() {
    $(document.body).addClass('fp-animate-ready');

    this.$menuWrapper = $('.menu');

    $('#fullpage').fullpage({
      menu: '#menu, #mobile-menu',
      normalScrollElements: '.gallery__images',
      responsiveWidth: 750,
      afterRender: () => {
        this.init()
      },
      onLeave: (index, nextIndex, direction) => {
        if (window.innerWidth <= 750) {
          if (nextIndex > 1) {
            this.$menuWrapper.addClass('menu--colored')
          }
        } else {
          switch (nextIndex) {
            case 2:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 3:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 4:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 5:
              this.$menuWrapper.addClass('menu--colored')
              break
            // case 6:
            //   this.$menuWrapper.addClass('menu--colored')
            //   break
            case 7:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 8:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 9:
              this.$menuWrapper.addClass('menu--colored')
              break
            case 10:
              this.$menuWrapper.addClass('menu--colored')
              break
            default:
              this.$menuWrapper.removeClass('menu--colored')
              break
          }
        }
      },
      afterLoad: (anchorLink, index) => {
        if (window.innerWidth <= 750 && index === 1) {
          this.$menuWrapper.removeClass('menu--colored')

        }
      },

      afterResize: () => {
        // console.log('resize');
        setTimeout(() => {
          if (this.map) this.map.resize();
          if (this.mapContact) this.mapContact.resize()
        }, 500)
      }

    })

  }

  /**
   * Инициализцаия основлены компонеты поле готовности fullpage.js
   */

  init () {
    this.initModals();
    this.mobileMenu();
    objectFitImages();
    this.map = new Map('map');
    // this.scrollGallery();
    this.validateInputMask();
    this.sendPromotionRequest();
  }

  initModals () {
    this.modalProcess();
  }

  /**
   * Обработка скрола на блоке галереи и пролистываение слайдера когда скрол блока завершен
   */
  // scrollGallery () {
  //   $('.gallery__images').on('scroll', function (e) {
  //     let $this = $(this);
  //
  //     // console.log($this.scrollTop());
  //     // console.log($this.innerHeight());
  //
  //     if ($this.scrollTop() === 0) {
  //       $.fn.fullpage.moveSectionUp();
  //       return
  //     }
  //
  //     if ($this.scrollTop() + $this.innerHeight() >= $this[0].scrollHeight) {
  //       $.fn.fullpage.moveSectionDown()
  //     }
  //   }).on('mousewheel', function (event) {
  //     if (window.innerWidth <= 750) {
  //       return
  //     }
  //
  //     if ($(this)[0].scrollHeight === $(this).innerHeight()) {
  //       if (event.originalEvent.wheelDelta >= 0) {
  //         // console.log('Scroll up')
  //         $.fn.fullpage.moveSectionUp()
  //       } else {
  //         // console.log('Scroll down')
  //         $.fn.fullpage.moveSectionDown()
  //       }
  //     }
  //   })
  // }

  /**
   * Открытие/закрытие выподающего меню
   */
  mobileMenu () {
    this.$dropMenu = $('.menu-site');

    $('.gamburger').on('click', () => {
      this.$dropMenu.addClass('menu-site--open')
    })

    $('.menu-close').on('click', () => {
      this.$dropMenu.removeClass('menu-site--open')
    })

    this.$menuList = $('#mobile-menu');

    this.$menuList
      .find('a')
      .on('click', () => {
        setTimeout(() => {
          this.$dropMenu.removeClass('menu-site--open')
        }, 300)
      })
  }

  /**
   * Открытие попапа
   */

  modalProcess () {
    $('#engineerModal').on('click', function (e) {
      e.preventDefault()
      $('#myModal').modal('show')
    });

    let hrefNumber = $('.js-phone0:first').attr('href');
    // let phoneNumber = $('.js-phone0:first').text();
    // let $jsPhone = $('.js-phone');
    //
    // $jsPhone.attr('href' , hrefNumber).text(phoneNumber);

    let isClickInit = false;

    $(window).on('resize', debounce(() => {
      if (window.innerWidth >= 991) {
        if(!isClickInit) {
          $('.js-download-presentation').off('click').on('click', function (e) {
            e.preventDefault();
            let hrefNumber = $('.js-number-phone').attr('href');
            let phoneNumber = $('.js-number-phone').text();
            let $jsPhone = $('.modal-title--link');
            $jsPhone.attr('href' , hrefNumber).text(phoneNumber);
            $('.form-control').attr('placeholder' , phoneNumber);

            $('#modal-presentation').modal('show')
          });
          isClickInit = true;
        }
      } else {
        if(isClickInit) {
          $('.js-download-presentation').off('click');
          isClickInit = false
        }
      }
    })).trigger('resize');
  }

  validateInputMask() {
    $('.js-input-stock-feedback').mask('+0(000)000-00-00');
  }

  sendPromotionRequest() {
    $('.js-form-stock-feedback').on('submit', function (event) {
      event.preventDefault();
      const $form = $(this);

      $.ajax({
        type: "post",
        url: $form.attr('action'),
        data: $form.serialize(),
        success: function () {
          alert('Ваша заявка принята!');
        },
        error: function (data) {
          console.log(`Error: ${data.status}`);
          alert('Ваша заявка отклонена!');
        }
      });
    })
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/site-constructor/index.js